module.exports = __webpack_public_path__ + "img/trest.342a5487.jpg";